import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  .financing {
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;

    a {
      color: ${({ theme }) => theme.colors.french};
      text-decoration: underline;
    }

    .affirm-modal-trigger {
      display: inline;
      text-align: center;
    }
  }
`;

function Affirm({ price }) {
  /* useEffect(() => {
    if (
      window.affirm &&
      window.affirm.ui &&
      typeof window.affirm.ui.refresh == 'function'
    ) {
      window.affirm.ui.refresh();
    }
  }, [window.affirm, price]);
  return (
    <Wrapper>
      {price > 49 ? (
        <div className="financing">
          <p
            className="affirm-as-low-as financing-offer"
            data-page-type="product"
            data-amount={`${price * 100}`}
          />
        </div>
      ) : (
        ''
      )}
    </Wrapper>
  );*/

  return null;
}

export default Affirm;
